<template>
  <header class="navbar is-fixed-top">
    <div class="navbar-brand">
      <router-link
        class="navbar-item"
        to="/"
      >
        <img
          class="logo"
          src="@/assets/ibs logo blanco.png"
          alt="AsiaIBS"
        >
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheHeader'
}
</script>

<style lang="scss" scoped>
  .navbar {
    background-color: var(--primary-blue);
    min-height: 70px;
    padding: 0 0 0 1rem;
  }

  .navbar-brand, .navbar-item {
    width: 200px;
  }
  .navbar-item img {
    max-height: 2.75rem;
  }

  img.logo {
    object-fit: cover;
  }

  a {
    font-size: 16px;
    color: white;
  }

  @media screen and (max-width: 1023px) {
    .navbar {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  }
</style>
